import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { IsAutocompleteComponent } from './base-components/is-autocomplete/is-autocomplete.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IsBackToTopComponent } from './base-components/is-back-to-top/is-back-to-top.component';
import { IsBackgroundGradientComponent } from './base-components/is-background-gradient/is-background-gradient.component';
import { IsBottomBarComponent } from './base-components/is-bottom-bar/is-bottom-bar.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FullCalendarModule } from '@fullcalendar/angular';
import { IsCalendarWidgetComponent } from './base-components/is-calendar-widget/is-calendar-widget.component';
import { IsCarouselComponent } from './base-components/is-carousel/is-carousel.component';
import { MatSelectModule } from '@angular/material/select';
import { IsDatePipeModule } from './pipes/is-date/is-date.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { IsDateNavigatorComponent } from './base-components/is-date-navigator/is-date-navigator.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MatListModule } from '@angular/material/list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatNativeDateModule } from '@angular/material/core';
import { MatOptionModule } from '@angular/material/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IsDropzoneComponent } from './base-components/is-dropzone/is-dropzone.component';
import { MatMenuModule } from '@angular/material/menu';
import { IsDynamicMatMenuComponent } from './base-components/is-dynamic-mat-menu/is-dynamic-mat-menu.component';
import { IsEmptyStateComponent } from './base-components/is-empty-state/is-empty-state.component';
import { IsEmptyStateChartComponent } from './base-components/is-empty-state-chart/is-empty-state-chart.component';
import { IsFatProgressBarComponent } from './base-components/is-fat-progress-bar/is-fat-progress-bar.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { IsFrequencySchedulerComponent } from './base-components/is-frequency-scheduler/is-frequency-scheduler.component';
import { IsGenericBottomBarComponent } from './base-components/is-generic-bottom-bar/is-generic-bottom-bar.component';
import { IsGenericToolbarComponent } from './base-components/is-generic-toolbar/is-generic-toolbar.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { IsGlobalSpinnerComponent } from './base-components/is-global-spinner/is-global-spinner.component';
import { MatCardModule } from '@angular/material/card';
import { IsImgCardComponent } from './base-components/is-img-card/is-img-card.component';
import { IsNavigationStickerButtonComponent } from './base-components/is-navigation-sticker-button/is-navigation-sticker-button.component';
import { IsPaginatorComponent } from './base-components/is-paginator/is-paginator.component';
import { IsPeriodNavigatorComponent } from './base-components/is-period-navigator/is-period-navigator.component';
import { IsPhotoCardComponent } from './base-components/is-photo-card/is-photo-card.component';
import { IsPiechartComponent } from './base-components/is-piechart/is-piechart.component';
import { IsSignatureComponent } from './base-components/is-signature/is-signature.component';
import { IsSliderComponent } from './base-components/is-slider/is-slider.component';
import { SearchFiltersComponent } from './base-components/search-filters/search-filters.component';
import { IsDeleteDialogModule } from './components/is-delete-dialog/is-delete-dialog.module';

const baseComponents: any = [
  IsAutocompleteComponent,
  IsBackToTopComponent,
  IsBackgroundGradientComponent,
  IsBottomBarComponent,
  IsCalendarWidgetComponent,
  IsCarouselComponent,
  IsDateNavigatorComponent,
  IsDropzoneComponent,
  IsDynamicMatMenuComponent,
  IsEmptyStateComponent,
  IsEmptyStateChartComponent,
  IsFatProgressBarComponent,
  IsFrequencySchedulerComponent,
  IsGenericBottomBarComponent,
  IsGenericToolbarComponent,
  IsGlobalSpinnerComponent,
  IsImgCardComponent,
  IsNavigationStickerButtonComponent,
  IsPaginatorComponent,
  IsPeriodNavigatorComponent,
  IsPhotoCardComponent,
  IsPiechartComponent,
  IsSignatureComponent,
  IsSliderComponent,
  SearchFiltersComponent
];

@NgModule({
  declarations: [baseComponents],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatIconModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatToolbarModule,
    MatSlideToggleModule,
    FullCalendarModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    IsDatePipeModule,
    MatSelectModule,
    NgxDropzoneModule,
    MatListModule,
    MatDialogModule,
    MatDividerModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    MatCheckboxModule,
    MatNativeDateModule,
    MatMenuModule,
    NgxMaterialTimepickerModule,
    OverlayModule,
    PortalModule,
    MatCardModule,
    IsDeleteDialogModule
  ],
  exports: [baseComponents]
})
export class IsBaseUiModule { }
